var users = [
  {
    id: 1,
    name: "Leanne Graham",
    username: "Bret",
    yearlyIncome: 98000,
    email: "Sincere@april.biz",
    img: "https://www.gstatic.com/tv/thumb/persons/378/378_v9_bd.jpg",
    address: {
      street: "Kulas Light",
      suite: "Apt. 556",
      city: "Gwenborough",
      zipcode: "92998-3874",
      geo: {
        lat: "-37.3159",
        lng: "81.1496",
      },
    },
    phone: "1-770-736-8031 x56442",
    website: "hildegard.org",
    company: {
      name: "Romaguera-Crona",
      catchPhrase: "Multi-layered client-server neural-net",
      bs: "harness real-time e-markets",
    },
  },
  {
    id: 2,
    name: "Ervin Howell",
    username: "Antonette",
    yearlyIncome: 85000,
    email: "Shanna@melissa.tv",
    img: "https://www.gstatic.com/tv/thumb/persons/378/378_v9_bd.jpg",
    address: {
      street: "Victor Plains",
      suite: "Suite 879",
      city: "Wisokyburgh",
      zipcode: "90566-7771",
      geo: {
        lat: "-43.9509",
        lng: "-34.4618",
      },
    },
    phone: "010-692-6593 x09125",
    website: "anastasia.net",
    company: {
      name: "Deckow-Crist",
      catchPhrase: "Proactive didactic contingency",
      bs: "synergize scalable supply-chains",
    },
  },
  {
    id: 3,
    name: "Clementine Bauch",
    username: "Samantha",
    yearlyIncome: 95000,
    email: "Nathan@yesenia.net",
    img: "https://www.gstatic.com/tv/thumb/persons/378/378_v9_bd.jpg",
    address: {
      street: "Douglas Extension",
      suite: "Suite 847",
      city: "McKenziehaven",
      zipcode: "59590-4157",

      geo: {
        lat: "-68.6102",
        lng: "-47.0653",
      },
    },
    phone: "1-463-123-4447",
    website: "ramiro.info",
    company: {
      name: "Romaguera-Jacobson",
      catchPhrase: "Face to face bifurcated interface",
      bs: "e-enable strategic applications",
    },
  },
  {
    id: 4,
    name: "Patricia Lebsack",
    username: "Karianne",
    yearlyIncome: 35000,
    email: "Julianne.OConner@kory.org",
    img:
      "https://cdn.britannica.com/87/186687-050-3AA9E551/Justin-Trudeau-2015.jpg",
    address: {
      street: "Hoeger Mall",
      suite: "Apt. 692",
      city: "South Elvis",
      zipcode: "53919-4257",

      geo: {
        lat: "29.4572",
        lng: "-164.2990",
      },
    },
    phone: "493-170-9623 x156",
    website: "kale.biz",
    company: {
      name: "Robel-Corkery",
      catchPhrase: "Multi-tiered zero tolerance productivity",
      bs: "transition cutting-edge web services",
    },
  },
  {
    id: 5,
    name: "Chelsey Dietrich",
    username: "Kamren",
    yearlyIncome: 55000,
    email: "Lucio_Hettinger@annie.ca",
    img:
      "https://cdn.britannica.com/87/186687-050-3AA9E551/Justin-Trudeau-2015.jpg",
    address: {
      street: "Skiles Walks",
      suite: "Suite 351",
      city: "Roscoeview",
      zipcode: "33263",

      geo: {
        lat: "-31.8129",
        lng: "62.5342",
      },
    },
    phone: "(254)954-1289",
    website: "demarco.info",
    company: {
      name: "Keebler LLC",
      catchPhrase: "User-centric fault-tolerant solution",
      bs: "revolutionize end-to-end systems",
    },
  },
  {
    id: 6,
    name: "Mrs. Dennis Schulist",
    yearlyIncome: 35000,
    username: "Leopoldo_Corkery",
    email: "Karley_Dach@jasper.info",
    img:
      "https://cdn.britannica.com/87/186687-050-3AA9E551/Justin-Trudeau-2015.jpg",
    address: {
      street: "Norberto Crossing",
      suite: "Apt. 950",
      city: "South Christy",
      zipcode: "23505-1337",

      geo: {
        lat: "-71.4197",
        lng: "71.7478",
      },
    },
    phone: "1-477-935-8478 x6430",
    website: "ola.org",
    company: {
      name: "Considine-Lockman",
      catchPhrase: "Synchronised bottom-line interface",
      bs: "e-enable innovative applications",
    },
  },
  {
    id: 7,
    name: "Kurtis Weissnat",
    username: "Elwyn.Skiles",
    yearlyIncome: 35000,
    email: "Telly.Hoeger@billy.biz",
    img:
      "https://cdn.britannica.com/87/186687-050-3AA9E551/Justin-Trudeau-2015.jpg",
    address: {
      street: "Rex Trail",
      suite: "Suite 280",
      city: "Howemouth",
      zipcode: "58804-1099",

      geo: {
        lat: "24.8918",
        lng: "21.8984",
      },
    },
    phone: "210.067.6132",
    website: "elvis.io",
    company: {
      name: "Johns Group",
      catchPhrase: "Configurable multimedia task-force",
      bs: "generate enterprise e-tailers",
    },
  },
  {
    id: 8,
    name: "Nicholas Runolfsdottir V",
    username: "Maxime_Nienow",
    yearlyIncome: 35000,
    email: "Sherwood@rosamond.me",
    img:
      "https://cdn.britannica.com/87/186687-050-3AA9E551/Justin-Trudeau-2015.jpg",
    address: {
      street: "Ellsworth Summit",
      suite: "Suite 729",
      city: "Aliyaview",
      zipcode: "45169",

      geo: {
        lat: "-14.3990",
        lng: "-120.7677",
      },
    },
    phone: "586.493.6943 x140",
    website: "jacynthe.com",
    company: {
      name: "Abernathy Group",
      catchPhrase: "Implemented secondary concept",
      bs: "e-enable extensible e-tailers",
    },
  },
  {
    id: 9,
    name: "Glenna Reichert",
    username: "Delphine",
    yearlyIncome: 15000,
    email: "Chaim_McDermott@dana.io",
    img:
      "https://cdn.britannica.com/87/186687-050-3AA9E551/Justin-Trudeau-2015.jpg",
    address: {
      street: "Dayna Park",
      suite: "Suite 449",
      city: "Bartholomebury",
      zipcode: "76495-3109",

      geo: {
        lat: "24.6463",
        lng: "-168.8889",
      },
    },
    phone: "(775)976-6794 x41206",
    website: "conrad.com",
    company: {
      name: "Yost and Sons",
      catchPhrase: "Switchable contextually-based project",
      bs: "aggregate real-time technologies",
    },
  },
  {
    id: 10,
    name: "Clementina DuBuque",
    username: "Moriah.Stanton",
    yearlyIncome: 42000,
    email: "Rey.Padberg@karina.biz",
    img:
      "https://cdn.britannica.com/87/186687-050-3AA9E551/Justin-Trudeau-2015.jpg",
    address: {
      street: "Kattie Turnpike",
      suite: "Suite 198",
      city: "Lebsackbury",
      zipcode: "31428-2261",

      geo: {
        lat: "-38.2386",
        lng: "57.2232",
      },
    },
    phone: "024-648-3804",
    website: "ambrose.net",
    company: {
      name: "Hoeger LLC",
      catchPhrase: "Centralized empowering task-force",
      bs: "target end-to-end models",
    },
  },

  {
    id: 11,
    name: "ILeanne Jraham",
    username: "Bret",
    yearlyIncome: 35050,
    email: "Sincere@april.biz",
    img:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Sophie_Gregoire_2017.jpg",
    address: {
      street: "Kulas Light",
      suite: "Apt. 556",
      city: "Gwenborough",
      zipcode: "92998-3874",

      geo: {
        lat: "-37.3159",
        lng: "81.1496",
      },
    },
    phone: "1-770-736-8031 x56442",
    website: "hildegard.org",
    company: {
      name: "Romaguera-Crona",
      catchPhrase: "Multi-layered client-server neural-net",
      bs: "harness real-time e-markets",
    },
  },
  {
    id: 12,
    name: "Ervin Howell",
    username: "Antonette",
    yearlyIncome: 25000,
    email: "Shanna@melissa.tv",
    img:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Sophie_Gregoire_2017.jpg",
    address: {
      street: "Victor Plains",
      suite: "Suite 879",
      city: "Wisokyburgh",
      zipcode: "90566-7771",

      geo: {
        lat: "-43.9509",
        lng: "-34.4618",
      },
    },
    phone: "010-692-6593 x09125",
    website: "anastasia.net",
    company: {
      name: "Deckow-Crist",
      catchPhrase: "Proactive didactic contingency",
      bs: "synergize scalable supply-chains",
    },
  },
  {
    id: 13,
    name: "Clementine Bauch",
    username: "Samantha",
    yearlyIncome: 35000,
    email: "Nathan@yesenia.net",
    img:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Sophie_Gregoire_2017.jpg",
    address: {
      street: "Douglas Extension",
      suite: "Suite 847",
      city: "McKenziehaven",
      zipcode: "59590-4157",

      geo: {
        lat: "-68.6102",
        lng: "-47.0653",
      },
    },
    phone: "1-463-123-4447",
    website: "ramiro.info",
    company: {
      name: "Romaguera-Jacobson",
      catchPhrase: "Face to face bifurcated interface",
      bs: "e-enable strategic applications",
    },
  },
  {
    id: 14,
    name: "Patricia Lebsack",
    username: "Karianne",
    yearlyIncome: 78000,
    email: "Julianne.OConner@kory.org",
    img:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Sophie_Gregoire_2017.jpg",
    address: {
      street: "Hoeger Mall",
      suite: "Apt. 692",
      city: "South Elvis",
      zipcode: "53919-4257",

      geo: {
        lat: "29.4572",
        lng: "-164.2990",
      },
    },
    phone: "493-170-9623 x156",
    website: "kale.biz",
    company: {
      name: "Robel-Corkery",
      catchPhrase: "Multi-tiered zero tolerance productivity",
      bs: "transition cutting-edge web services",
    },
  },
  {
    id: 15,
    name: "Chelsey Dietrich",
    username: "Kamren",
    yearlyIncome: 65000,
    email: "Lucio_Hettinger@annie.ca",
    img:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Sophie_Gregoire_2017.jpg",
    address: {
      street: "Skiles Walks",
      suite: "Suite 351",
      city: "Roscoeview",
      zipcode: "33263",

      geo: {
        lat: "-31.8129",
        lng: "62.5342",
      },
    },
    phone: "(254)954-1289",
    website: "demarco.info",
    company: {
      name: "Keebler LLC",
      catchPhrase: "User-centric fault-tolerant solution",
      bs: "revolutionize end-to-end systems",
    },
  },
  {
    id: 16,
    name: "Mrs. Dennis Schulist",
    username: "Leopoldo_Corkery",
    yearlyIncome: 55000,
    email: "Karley_Dach@jasper.info",
    img:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Sophie_Gregoire_2017.jpg",
    address: {
      street: "Norberto Crossing",
      suite: "Apt. 950",
      city: "South Christy",
      zipcode: "23505-1337",

      geo: {
        lat: "-71.4197",
        lng: "71.7478",
      },
    },
    phone: "1-477-935-8478 x6430",
    website: "ola.org",
    company: {
      name: "Considine-Lockman",
      catchPhrase: "Synchronised bottom-line interface",
      bs: "e-enable innovative applications",
    },
  },
  {
    id: 17,
    name: "Kurtis Weissnat",
    username: "Elwyn.Skiles",
    yearlyIncome: 45000,
    email: "Telly.Hoeger@billy.biz",
    img:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Sophie_Gregoire_2017.jpg",
    address: {
      street: "Rex Trail",
      suite: "Suite 280",
      city: "Howemouth",
      zipcode: "58804-1099",

      geo: {
        lat: "24.8918",
        lng: "21.8984",
      },
    },
    phone: "210.067.6132",
    website: "elvis.io",
    company: {
      name: "Johns Group",
      catchPhrase: "Configurable multimedia task-force",
      bs: "generate enterprise e-tailers",
    },
  },
  {
    id: 18,
    name: "Nicholas Runolfsdottir V",
    username: "Maxime_Nienow",
    yearlyIncome: 37000,
    email: "Sherwood@rosamond.me",
    img:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Sophie_Gregoire_2017.jpg",
    address: {
      street: "Ellsworth Summit",
      suite: "Suite 729",
      city: "Aliyaview",
      zipcode: "45169",

      geo: {
        lat: "-14.3990",
        lng: "-120.7677",
      },
    },
    phone: "586.493.6943 x140",
    website: "jacynthe.com",
    company: {
      name: "Abernathy Group",
      catchPhrase: "Implemented secondary concept",
      bs: "e-enable extensible e-tailers",
    },
  },
  {
    id: 19,
    name: "Glenna Reichert",
    username: "Delphine",
    yearlyIncome: 35400,
    email: "Chaim_McDermott@dana.io",
    img:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Sophie_Gregoire_2017.jpg",
    address: {
      street: "Dayna Park",
      suite: "Suite 449",
      city: "Bartholomebury",
      zipcode: "76495-3109",

      geo: {
        lat: "24.6463",
        lng: "-168.8889",
      },
    },
    phone: "(775)976-6794 x41206",
    website: "conrad.com",
    company: {
      name: "Yost and Sons",
      catchPhrase: "Switchable contextually-based project",
      bs: "aggregate real-time technologies",
    },
  },
  {
    id: 20,
    name: "Clementina DuBuque",
    username: "Moriah.Stanton",
    email: "Rey.Padberg@karina.biz",
    yearlyIncome: 35000,
    img:
      "https://upload.wikimedia.org/wikipedia/commons/0/05/Sophie_Gregoire_2017.jpg",
    address: {
      street: "Kattie Turnpike",
      suite: "Suite 198",
      city: "Lebsackbury",
      zipcode: "31428-2261",

      geo: {
        lat: "-38.2386",
        lng: "57.2232",
      },
    },
    phone: "024-648-3804",
    website: "ambrose.net",
    company: {
      name: "Hoeger LLC",
      catchPhrase: "Centralized empowering task-force",
      bs: "target end-to-end models",
    },
  },
];

export default users;
